/* ==========================================================================
                    PRODUCT PAGE BACK NAVIGATION
   ========================================================================== */

// This file is intentionally minimal. It does NOT intercept browser back.
// Instead, it ensures collection state is preserved for the collection page
// to restore when the user navigates back naturally.

class ProductBackNavigation {
  constructor() {
    this.isProductPage = this.detectProductPage();

    if (this.isProductPage) {
      this.init();
    }
  }

  detectProductPage() {
    return window.location.pathname.includes('/products/') ||
           document.body.classList.contains('template-product') ||
           document.querySelector('[data-section-type="product"]') !== null;
  }

  init() {
    // Just ensure collection state timestamp is fresh
    // so the collection page knows this is a recent navigation
    this.refreshCollectionState();
    console.log('[Product Back Nav] Initialized - collection state refreshed');
  }

  refreshCollectionState() {
    try {
      const stored = sessionStorage.getItem('collection_state');
      if (stored) {
        const state = JSON.parse(stored);
        // Update timestamp to mark as recent
        state.timestamp = Date.now();
        sessionStorage.setItem('collection_state', JSON.stringify(state));
        console.log('[Product Back Nav] Refreshed collection state:', state);
      }
    } catch (error) {
      console.warn('[Product Back Nav] Failed to refresh collection state:', error);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductBackNavigation();
  });
} else {
  new ProductBackNavigation();
}

window.ProductBackNavigation = ProductBackNavigation;